import { render, staticRenderFns } from "./deal.vue?vue&type=template&id=6de045c0&scoped=true&"
import script from "./deal.vue?vue&type=script&lang=js&"
export * from "./deal.vue?vue&type=script&lang=js&"
import style0 from "./deal.vue?vue&type=style&index=0&id=6de045c0&lang=scss&scoped=true&"
import style1 from "./deal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de045c0",
  null
  
)

export default component.exports